module.exports = __webpack_public_path__ + "static/img/merchant_feature_11.80831cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/merchant_feature_11.png
// module id = YqAo
// module chunks = 8